// Pantalla "Acerca de" con atribuciones. Requisito para publicar la app en Play Store:
// la licencia de OSM (ODbL) exige atribución visible/accesible al usuario final. Aprovechamos
// para explicar de dónde vienen los datos del bus (plano oficial) y las limitaciones.
//
// Se abre desde el "Acerca de" del propio diálogo de ajustes; no ocupa espacio en el shell.

const html = String.raw;

export function openAbout(): void {
  let overlay = document.getElementById("about-overlay") as HTMLDivElement | null;
  if (overlay) return; // ya abierto
  overlay = document.createElement("div");
  overlay.id = "about-overlay";
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.setAttribute("aria-labelledby", "about-title");
  overlay.innerHTML = html`
    <div class="about-box">
      <h2 id="about-title">Bus Elx</h2>
      <p class="about-lead">
        Aplicación no oficial con las 30 líneas del bus de Elche: urbanas, cementerios, nocturna y
        pedanías. Uso libre, sin cuentas.
      </p>
      <h3>Datos del bus</h3>
      <p>
        Tiempos de llegada de AUESA. Posiciones de autobuses estimadas, sin GPS de vehículos.
        Trazados de las relaciones de bus de OpenStreetMap y, donde no hay, del camino por calles de
        OSRM. Los autobuses del mapa se deducen de los tiempos de llegada: su posición es
        aproximada.
      </p>
      <h3>Mapa y búsqueda</h3>
      <p>
        Mapa base: vector tiles de
        <a href="https://openfreemap.org" target="_blank" rel="noopener">OpenFreeMap</a>
        sobre datos de
        <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener"
          >© OpenStreetMap</a
        >
        contribuidores, bajo licencia
        <a href="https://opendatacommons.org/licenses/odbl/1-0/" target="_blank" rel="noopener"
          >ODbL 1.0</a
        >. Búsqueda y sugerencias de direcciones a través de
        <a href="https://photon.komoot.io" target="_blank" rel="noopener">Photon</a> (Komoot).
      </p>
      <h3>Software</h3>
      <p>
        Cliente: TypeScript + MapLibre GL + Vite. Planificador local (Dijkstra) sin servidor. Sin
        analítica, sin tracking, sin cuentas.
      </p>
      <button id="about-close" type="button">Cerrar</button>
    </div>
  `;
  document.body.appendChild(overlay);
  overlay.querySelector<HTMLButtonElement>("#about-close")?.addEventListener("click", () => {
    overlay?.remove();
  });
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) overlay?.remove();
  });
}
